<template>
  <div class="block-header" :class="{ likable, checkable }">
    <BlockElementLike v-if="likable" :selected="like" class="like" :size="3" />
    <TextElement :tag="heading" class="title"><slot /></TextElement>
    <BlockElementCheck v-if="checkable" :selected="check" class="check" />
  </div>
</template>
<script lang="ts" setup>
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineEmits(["update:like", "update:check"]);
interface Props {
  likable?: boolean;
  checkable?: boolean;
  heading?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
}
const { like, check } = __MACROS_useVModel("like", "check");
defineProps({
  likable: { type: Boolean },
  checkable: { type: Boolean, default: false },
  heading: { default: 'h3' },
  like: { type: Boolean, default: null },
  check: { type: Boolean }
});
</script>
<style lang="scss" scoped>
.block-header {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: var(--gap_n);

  &.likable {
    grid-template-columns: 3rem 1fr;
  }
  &.checkable {
    grid-template-columns: 1fr 4rem;
  }
  &.likable.checkable {
    grid-template-columns: 3rem 1fr 4rem;
  }
}
.like,
.check {
  flex-shrink: 0;
}
.title {
  flex-shrink: 2;
}
</style>
